import { getDefaultStyleParams } from './viewerScript/getDefaultStyleParams';
export function getStyleParamsWithDefaultsFunc(_a) {
    var styleParams = _a.style.styleParams, dimensions = _a.dimensions;
    function roundColumnsNumber() {
        if (styleParams.numbers.galleryColumns !== undefined) {
            styleParams.numbers.galleryColumns = Math.round(styleParams.numbers.galleryColumns);
        }
    }
    roundColumnsNumber();
    var _b = styleParams, showAlternativeImage = _b.booleans.showAlternativeImage, galleryColumns = _b.numbers.galleryColumns;
    return { defaults: getDefaultStyleParams(showAlternativeImage, galleryColumns, dimensions), overrides: styleParams };
}
//# sourceMappingURL=getStyleParamsWithDefaultsFunc.js.map